import { AppConfig, Environment, environments } from './types';

const getEnvironment = (value: string | undefined): Environment => {
  const env = (value || 'dev') as Environment;

  if (environments.includes(env)) {
    return env;
  }

  throw new Error('Invalid environment');
};

export const environment = getEnvironment(process.env.REACT_APP_ENV);
export const enableShopifyVenueID = process.env.REACT_APP_ENABLE_SHOPIFY_VENUE_ID;

export const assetsURL = 'https://d17si0wrotzxzi.cloudfront.net/';

type ConfigEnv = {
  [key in Environment]: AppConfig;
};

const GOOGLE_MAPS_APIKEY = process.env.REACT_APP_GOOGLE_MAP_API ?? '';
const SHOPIFY_CLIENT_ID = process.env.REACT_APP_SHOPIFY_CLIENT_ID ?? '';

const dev: AppConfig = {
  googleMapApiKey: GOOGLE_MAPS_APIKEY,
  stripKey:
    'pk_test_51Sxk1VP4kZiNMzXUou6Hd4OdyKqDtFY5wCikIMnuFGZZ9nF3ZPLjhen0GLsmRfC9qancYxpyyK6ZnEblkTkeSTRL00n1pm2r2D',
  shopifyClientId: SHOPIFY_CLIENT_ID,
};

const config: ConfigEnv = {
  local: { ...dev },
  dev,
  production: {
    googleMapApiKey: GOOGLE_MAPS_APIKEY,
    stripKey:
      'pk_live_51Sxk1I0W62iPmXnsCfYPKqH5WOHhDa9J1VLh61Dgru0SstTTSUYu6QRq7AkF8F6NaCp4NEtzjpY29iVpnE70SpaV00Ojx6a06y',
    shopifyClientId: SHOPIFY_CLIENT_ID,
  },
};

export default config[environment];
